import bookmark from "../../data/bookmark"
import productSidebar from "@/data/productSidebar"
import usercard from "@/data/usercard"
import faq from "@/data/faq"
import {All,Doing,Done} from '../../data/projectlist/data';

const state = {
	allprojects : All,
	doingprojects : Doing,
	doneprojects : Done,
    bookmark : bookmark.data,
	swiper:productSidebar.data,
	menu:usercard.data,
	featured : faq.featured,
    articles : faq.articles,
    articles1 : faq.articles1,
    articles2 : faq.articles2,
	activeclass : 'pills_created',
	favourite:[],
	
};


const getters = {
activeclass:(state)=>{ return state.activeclass}
}


const mutations = {
	active:(state,payload)=>{
		state.activeclass = payload
	},
	setFavourite:(state,payload)=>{
		let objIndex = state.favourite.findIndex((obj => obj.id === payload.id));
		if (objIndex > -1) 
		{
		state.favourite.splice(objIndex, 1);
		} else {
		state.favourite.push(payload);
		}	},
	getActive:(state,payload)=>{
		let objIndex = state.favourite.findIndex((obj => obj.id === payload));
		if (objIndex > -1) {
		return true;
		} else {
		return false;
		}
	},
	add:(state,payload)=>{
		state.bookmark.push(payload);
		
	}
};


const actions = {
	active:(context,payload)=>
	{
		context.commit('active',payload);
	},
	setFavourite:(context,payload)=>{
		context.commit('setFavourite',payload)
	},
	getActive:(context,payload)=>{
		context.commit('getActive',payload)
	}

};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};